module.exports = __webpack_public_path__ + "static/img/unit_distributor.98ca925f.png";